import { Backdrop, Box } from '@mui/material';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';

const CustomLinearProgressBar = styled(LinearProgress)(() => ({
	[`&.${linearProgressClasses.colorPrimary}`]: {
		backgroundColor: '#B9A8DE',
	},
	[`& .${linearProgressClasses.bar}`]: {
		backgroundColor: '#8E5EF4',
	},
}));

const CompleteLinearProgressBar = styled(LinearProgress)(() => ({
	[`&.${linearProgressClasses.colorPrimary}`]: {
		backgroundColor: '#8E5EF4',
	},
	[`& .${linearProgressClasses.bar}`]: {
		backgroundColor: '#8E5EF4',
	},
}));

export const ProgressPill = ({
	complete = false,
	messageTitle = 'Loading',
	messageText = 'Please wait...',
	size = 'small',
	fullscreen = true,
}: {
	complete?: boolean;
	messageTitle?: string;
	messageText?: string;
	size?: 'medium' | 'small';
	fullscreen?: boolean;
}) => {
	const pill = (
		<div
			style={{
				borderRadius: size === 'medium' ? '24px' : '15px',
				width: size === 'medium' ? '576px' : '360px',
				padding: size === 'medium' ? '0 32px' : '0 20px',
				position: fullscreen ? 'absolute' : undefined,
				borderColor: '#CCCCCC',
			}}
			className="mx-auto bg-white border"
		>
			<div
				style={{ color: '#323232', padding: size === 'medium' ? '8px 0' : '2px 0' }}
				className="flex-1 pb-2 text-center text-base overflow-x-hidden text-nowrap text-ellipsis"
			>
				{messageTitle}
			</div>

			<Box sx={{ width: '100%' }}>{complete ? <CompleteLinearProgressBar /> : <CustomLinearProgressBar />}</Box>

			<div
				style={{ color: '#323232', padding: size === 'medium' ? '8px 0' : '2px 0' }}
				className="flex-1 text-xs overflow-x-hidden text-nowrap text-ellipsis"
			>
				{messageText}
			</div>
		</div>
	);

	if (!fullscreen) {
		return pill;
	}

	return (
		<Backdrop sx={() => ({ color: '#FFFFFF', zIndex: 9999999 })} open invisible>
			{pill}
		</Backdrop>
	);
};
